import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress'
import PropTypes from 'prop-types'

const useStyles = makeStyles(theme => ({
  progress: {
    margin: 3 * theme.spacing(2),
  },
}));

function ProgressDialog(props) {

  const { show, height } = props;

  const classes = useStyles();

  return (
    <div style={{display: show ? `flex` : `none`, justifyContent: `center`, width: `100%`}}>
      <CircularProgress className={classes.progress} size={height / 2} /> 
    </div>
  );
}

ProgressDialog.propTypes = {
  show: PropTypes.bool.isRequired,
  height: PropTypes.number
}

ProgressDialog.defaultProps = {
  height: 80 // 40px is the default as defined by Material-UI
}


export default ProgressDialog;